import { useFormContext, Controller } from 'react-hook-form';
import type { InputHTMLAttributes } from 'react';
import type { FieldError } from 'react-hook-form';
import EmailInput from './EmailInput';

type FormEmailInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: FieldError;
  name: string;
  label?: string;
};

function FormEmailInput({
  error,
  name,
  ...restFieldProps
}: FormEmailInputProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, value } }) => (
        <EmailInput
          name={name}
          status={error && 'error'}
          extraText={error?.message}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...restFieldProps}
        />
      )}
    />
  );
}

export default FormEmailInput;
